import Alpine from 'alpinejs';

window.Alpine = Alpine;

export default {
  init() {
    // JavaScript to be fired on all pages
    if (typeof window.CookieConsent !== 'undefined') {
      window.CookieConsent.init({
        // More link URL on bar.
        modalMainTextMoreLink: null,
        // How long to wait until bar comes up.
        barTimeout: 500,
        // Look and feel.
        theme: {
          barColor: '#fff',
          barTextColor: '#272825',
          barMainButtonColor: '#007C4C',
          barMainButtonTextColor: '#fff',
          modalMainButtonColor: '#007C4C',
          modalMainButtonTextColor: '#fff',
        },
        language: {
          current: 'sv',
          locale: {
            sv: {
              barMainText: 'Denna webbplats använder cookies för att säkerställa att du får den bästa upplevelsen på vår webbplats.',
              closeAriaLabel: 'stäng',
              barLinkSetting: 'Cookie-inställningar',
              barBtnAcceptAll: 'Acceptera alla cookies',
              modalMainTitle: 'Cookie-inställningar',
              modalMainText: 'Cookies är små datastycken som skickas från en webbplats och lagras på användarens dator av användarens webbläsare medan användaren surfar. Din webbläsare lagrar varje meddelande i en liten fil, kallad cookie. När du begär en annan sida från servern skickar din webbläsare tillbaka cookien till servern. Cookies designades för att vara en pålitlig mekanism för webbplatser att komma ihåg information eller att registrera användarens surfaktivitet.',
              modalBtnSave: 'Spara aktuella inställningar',
              modalBtnAcceptAll: 'Acceptera alla cookies och stäng',
              modalAffectedSolutions: 'Påverkade lösningar:',
              learnMore: 'Läs mer',
              on: 'På',
              off: 'Av',
              enabled: 'är aktiverad.',
              disabled: 'är inaktiverad.',
              checked: 'markerad',
              unchecked: 'omarkerad',
            },
          },
        },
        // List all the categories you want to display.
        categories: {
          necessary: {
            needed: true,
            // The cookies in this category will be let trough.
            // This probably should be false if category not necessary.
            wanted: true,
            checked: true,
            language: {
              locale: {
                sv: {
                  name: 'Nödvändiga',
                  description: 'Nödvändiga cookies hjälper dig att göra en hemsida användbar, genom att aktivera grundläggande funktioner såsom sidnavigering åtkomst till säkra områden på hemsidan. Hemsidan kan inte fungera optimalt utan dessa cookies.',
                },
              },
            },
          },
          statistic: {
            needed: false,
            wanted: false,
            checked: true,
            language: {
              locale: {
                sv: {
                  name: 'Statistiska ',
                  description: 'Statistiska cookies hjälper hemsidans ägare att förstå hur besökare interagerar med hemsidan, genom att samla in och rapportera uppgifter.',
                },
              },
            },
          },
          marketing: {
            needed: false,
            wanted: false,
            checked: true,
            language: {
              locale: {
                sv: {
                  name: 'Marknadsföring',
                  description: 'Marketingcookies används för att spåra besökare gränsöverskridande på hemsidor. Avsikten är att visa annonser som är relevanta och engagerande för den enskilda användaren och därmed vara mer värdefulla för utgivare och tredjepartsannonsörer.',
                },
              },
            },
          },
        },
        // List actual services here.
        services: {
          // Unique name.
          analytics: {
            // Existing category Unique name.
            // This example shows how to block Google Analytics.
            category: 'statistic',
            // Type of blocking to apply here.
            // This depends on the type of script we are trying to block.
            // Can be: dynamic-script, script-tag, wrapped, localcookie.
            type: 'dynamic-script',
            // Only needed if "type: dynamic-script".
            // The filter will look for this keyword in inserted scipt tags
            //  and block if match found.
            search: 'analytics',
            // List of known cookie names or regular expressions matching
            //  cookie names placed by this service.
            // These will be removed from current domain and .domain.
            cookies: [
              {
                // Known cookie name.
                name: '_gid',
                // Expected cookie domain.
                domain: `.${window.location.hostname}`,
              },
              {
                // Regex matching cookie name.
                name: /^_ga/,
                domain: `.${window.location.hostname}`,
              },
            ],
            language: {
              locale: {
                sv: {
                  name: 'Google Analytics',
                },
              },
            },
          },
        },
        consentModeControls: {
          ad_storage: 'marketing',
          ad_user_data: 'marketing',
          ad_personalization: 'marketing',
          analytics_storage: 'statistic',
        },
      });
      console.log('end concent'); // eslint-disable-line no-console
    }
    Alpine.start();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
